import * as _ from "lodash-es";
import { getCurrentInstance, onUnmounted } from "vue";
import { type Listener, isListener } from "./listener";

export const useEventsBinding = (events: readonly string[]) => {
	const instance = getCurrentInstance();
	if (!instance) throw new Error("No Vue instance");

	const listeners: google.maps.MapsEventListener[] = [];

	const bindEvents = (object: Listener | Node) => {
		unbindEvents();

		for (const event of events) {
			const handler = _.throttle((e) => {
				setTimeout(() => {
					instance.emit(event, e);
				});
			}, 100);

			if (isListener(object)) {
				listeners.push(object.addListener(event, handler));
			} else {
				object.addEventListener(event, handler);
				listeners.push({
					remove: () => object.removeEventListener(event, handler),
				});
			}
		}
	};

	const unbindEvents = () => {
		for (const listener of listeners) {
			listener.remove();
		}

		listeners.length = 0;
	};

	onUnmounted(unbindEvents);

	return { bindEvents };
};
